export default "__VITE_ASSET__Bz4E_hho__"